import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router";
import {
  Row,
  Col,
  Breadcrumb,
  Button,
  Form,
  Modal,
  Alert,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import API from "../Utility";
import Spinner from "react-bootstrap/Spinner";
import { LinkContainer } from "react-router-bootstrap";
import Moment from "react-moment";
import {
  FaRegTrashAlt,
  FaRegSave,
  FaPlus,
  FaEdit,
  FaTimes,
  FaPaperPlane,
} from "react-icons/fa";
import ConfirmationModal from "../ConfirmationModal";
import LibrarySelector from "../LibrarySelector";
import PubHubAsset from "../PubHubAsset/PubHubAsset";

export default function UsersSingleView({ children, location, ...routeProps }) {
  let { project, userId } = useParams();
  let history = useHistory();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSendActivationEmailModal, setShowSendActivationEmailModal] =
    useState(false);

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteMessageShow, setDeleteMessageShow] = useState(false);
  const [selectedLibrary, setSelectedLibrary] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [activationModalTitle, setActivationModalTitle] = useState(null);

  const [fieldListOptions, setFieldListOptions] = useState({});

  async function getUserData(query) {
    try {
      setUserData([]);
      setIsLoading(true);
      const {
        _id,
        additionalFields,
        created,
        providerData,
        providerDataConfig,
        username,
        activationToken,
        isUserControlled,
        origin,
        mustActivate,
        password,
        groups,
        group,
      } = await API.get({
        url: query.url,
      });
      setIsLoading(false);
      setUserData({
        _id,
        additionalFields,
        created,
        providerData,
        providerDataConfig,
        username,
        activationToken,
        isUserControlled,
        origin,
        mustActivate,
        password,
        groups,
        group,
      });
      console.log(
        _id,
        additionalFields,
        created,
        providerData,
        providerDataConfig,
        username,
        activationToken,
        isUserControlled,
        origin,
        mustActivate
      );
      if (providerData && providerData.displayName) {
        setActivationModalTitle(
          `Send Activation Email - ${providerData.displayName}`
        );
      } else {
        setActivationModalTitle(`Send Activation Email - ${username}`);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    async function initializeData() {
      await getUserData({
        url: `/admin/${project}/users/${userId}`,
      });
    }

    initializeData();
  }, []);

  const tooltipPlacement = "top";
  const tooltipTitle = "Warning";
  const tooltipMessage =
    "This record is linked to an external data source that may overwrite your changes";

  const loading = () => {
    return userData.length < 1 && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>User not found</span>
      </div>
    );
  };

  const setUserFields = (user, field, index) => {
    if (field.fieldName === "username") {
      return (
        <tr key={index}>
          <th scope="row">{field.fieldLabel}</th>
          <td>{user[field.fieldName]}</td>
        </tr>
      );
    } else if (field.fieldName === "password") {
      return null;
    } else if (field.fieldName === "activationDate") {
      if (user.providerData[field.fieldName]) {
        return (
          <tr key={index}>
            <th scope="row">{field.fieldLabel}</th>
            <td>
              <Moment format="DD MMM 'YY">
                {user.providerData[field.fieldName]}
              </Moment>
            </td>
          </tr>
        );
      } else {
        return (
          <tr key={index}>
            <th scope="row">{field.fieldLabel}</th>
            <td></td>
          </tr>
        );
      }
    } else if (field.type === "date") {
      return (
        <tr key={index}>
          <th scope="row">{field.fieldLabel}</th>
          <td>
            {user && user.providerData[field.fieldName] ? (
              <Moment format="DD MMM 'YY">
                {user.providerData[field.fieldName]}
              </Moment>
            ) : null}
          </td>
        </tr>
      );
    } else if (field.type === "groups") {
      return (
        <tr key={index}>
          <th scope="row">Groups</th>
          <td>
            {user && user.groups ? (
              <>
                <div>
                  {user.groups
                    .sort((a, b) => {
                      if (a.name < b.name) {
                        return -1;
                      }
                      if (a.name > b.name) {
                        return 1;
                      }
                      return 0;
                    })
                    .map((g, i) => {
                      return <div key={i}>{g.name}</div>;
                    })}
                </div>
              </>
            ) : null}
          </td>
        </tr>
      );
    } else if (field.type === "group") {
      return (
        <tr key={index}>
          <th scope="row">{field.fieldLabel}</th>
          <td>{user && user.group ? <div>{user.group.name}</div> : null}</td>
        </tr>
      );
    } else {
      return (
        <tr key={index}>
          <th scope="row">{field.fieldLabel}</th>
          <td>{`${user.providerData[field.fieldName] === false ? "false" : user.providerData[field.fieldName] === undefined ? "" : user.providerData[field.fieldName]}`}</td>
        </tr>
      );
    }
  };

  const renderUserTable = (user) => {
    return (
      <table className="table table-bordered">
        <tbody>
          {user.providerDataConfig.map((field, index) =>
            setUserFields(user, field, index)
          )}
        </tbody>
      </table>
    );
  };

  const deleteUser = async () => {
    setDeleteModalShow(true);
  };
  const editUser = () => {
    history.push({
      pathname: `/users/${project}/${userId}/update`,
      state: { user: userData },
    });
  };

  const confirmDelete = async (event, exitValue) => {
    if (exitValue === true) {
      setDeleteMessageShow(true);
      await deleteResponse({
        url: `/admin/${project}/users/delete/${userId}`,
        data: userData,
      });
    } else {
      setDeleteModalShow(false);
    }
  };

  async function deleteResponse(query) {
    const response = await API.delete({
      url: query.url,
      data: query.data,
    });
    setDeleteModalShow(false);
    history.push(`/users/${project}`);
  }

  async function sendActivationEmail() {
    try {
      setIsLoading(true);
      const query = {
        url: `/admin/${project}/users/sendBulkActivations`,
        data: {
          setTokenIfNotSet: false,
          siteId: selectedLibrary,
          users: [userId],
        },
      };
      const response = await API.post({
        url: query.url,
        data: query.data,
      });
      if (response && response.sent) {
        setShowSendActivationEmailModal(false);
        setSubmitSuccess("Activation email(s) have been sent");
      }
      if (response && response.failed) {
        setShowSendActivationEmailModal(false);
        setSubmitError("An error occurred sending the activation email");
      }
      if (response && response.skipped) {
        setShowSendActivationEmailModal(false);
        setSubmitError("The user is already activated, email was not sent");
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setShowSendActivationEmailModal(false);
      setSubmitError("An error occurred sending the activation email");
    }
  }

  const onSelectLibrary = (e) => {
    setSelectedLibrary(e.target.value);
  };

  const phImageAsset = null;
  // {
  //   _id: "5d0102fc4231681d8b53cbd8",
  //   name: "office.jpg",
  //   path: "https://cdn.pubhubstudio.com/320be3eabd4176f053e7ec9edf66f1ef.jpeg",
  //   size: 361982,
  //   mimetype: "image/jpeg",
  //   assetpackage: "5d0102fc4231681d8b53cbd8",
  //   assetpackageName: "5d0102fc4231681d8b53cbd8",
  // };
  const phVideoAsset = {
    _id: "5d0102fc4231681d8b53cbd8",
    name: "caroussel.mp4",
    path: "https://cdn.pubhubstudio.com/e4d6f8ba7e0bf78b575dec5235770797.mp4",
    size: 5259601,
    mimetype: "video/mp4",
    assetpackage: "5d0102fc4231681d8b53cbd8",
    assetpackageName: "5d0102fc4231681d8b53cbd8",
  };
  const assetType = "image";

  return (
    <>
      <Row>
        <Col>
          <Breadcrumb as="nav" bsPrefix="breadcrumb ph-admin__breadcrumb">
            <LinkContainer to={`/users/${project}`}>
              <Breadcrumb.Item bsPrefix="breadcrumb-item clickable">
                Users
              </Breadcrumb.Item>
            </LinkContainer>
            <Breadcrumb.Item active>
              {userData && (userData.providerData || userData.username)
                ? userData.providerData.displayName || userData.username
                : ""}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        {/*<LibrarySelector/>*/}
      </Row>
      {userData && userData.providerData ? (
        <>
          <Row>
            <Col>
              <h2>{userData.providerData.displayName}</h2>
            </Col>

            <Col md="auto">
              <>
                {!userData.isUserControlled ? (
                  <OverlayTrigger
                    placement={tooltipPlacement}
                    overlay={
                      <Tooltip id="delete-tooltip-disabled">
                        <b>{tooltipTitle}</b>
                        <p>{tooltipMessage}</p>
                      </Tooltip>
                    }
                  >
                    <Button
                      className="float-right ml-2 mb-2"
                      variant="outline-primary"
                      onClick={deleteUser}
                    >
                      <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                      <span style={{ verticalAlign: "middle" }}>
                        Delete User
                      </span>
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    className="float-right ml-2 mb-2"
                    variant="outline-primary"
                    onClick={deleteUser}
                  >
                    <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}>Delete User</span>
                  </Button>
                )}

                <Button
                  className="float-right ml-2 mb-2"
                  variant="outline-primary"
                  onClick={(e) => setShowSendActivationEmailModal(true)}
                >
                  <FaPaperPlane style={{ verticalAlign: "middle" }} />
                  <span style={{ verticalAlign: "middle" }}>
                    Send Activation Email
                  </span>
                </Button>
                {!userData.isUserControlled ? (
                  <OverlayTrigger
                    placement={tooltipPlacement}
                    overlay={
                      <Tooltip id="delete-tooltip-disabled">
                        <b>{tooltipTitle}</b>
                        <p>{tooltipMessage}</p>
                      </Tooltip>
                    }
                  >
                    <Button
                      className="float-right mb-2"
                      variant="outline-primary"
                      onClick={editUser}
                    >
                      <FaEdit style={{ verticalAlign: "middle" }} />
                      <span style={{ verticalAlign: "middle" }}>Edit User</span>
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    className="float-right mb-2"
                    variant="outline-primary"
                    onClick={editUser}
                  >
                    <FaEdit style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}> Edit User</span>
                  </Button>
                )}
              </>
            </Col>
          </Row>
          <Row>
            <Col>{renderUserTable(userData)}</Col>
          </Row>
        </>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'center', justifyContent: 'center' }}>
          {loading()}
        </div>
      )}
      <ConfirmationModal
        title={activationModalTitle}
        show={showSendActivationEmailModal}
        body={
          <Form.Group>
            <LibrarySelector change={onSelectLibrary} />
          </Form.Group>
        }
        customfooter={
          <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
            <Button
              style={{ marginRight: "10px" }}
              onClick={(e) => setShowSendActivationEmailModal(false)}
              variant="outline-secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={(e) => sendActivationEmail()}
              variant="outline-primary"
              disabled={
                selectedLibrary === "0" ||
                selectedLibrary === null ||
                selectedLibrary === "Please select"
              }
            >
              Send
            </Button>
          </div>
        }
        confirmtext={"Save"}
        onHide={(event, exitValue) => {
          setShowSendActivationEmailModal(false);
        }}
        showspinner={isLoading}
      />
      <ConfirmationModal
        title={
          userData && userData.providerData && userData.providerData.displayName
            ? userData.providerData.displayName
            : userData.username
        }
        body={
          <>
            <p className={deleteMessageShow ? "hide" : ""}>
              {userData && !userData.isUserControlled ? (
                <Alert variant={"warning"}>
                  This record is linked to an external data source that may
                  overwrite your changes
                </Alert>
              ) : null}
              <br></br>
              Are you sure you want to delete this user?
            </p>
            <p className={deleteMessageShow ? "" : "hide"}>
              The delete will be done within the next few minutes.
            </p>
          </>
        }
        show={deleteModalShow}
        confirmtext={"Delete"}
        onHide={(event, exitValue) => {
          if (!deleteMessageShow) {
            confirmDelete(event, exitValue);
          }
        }}
        showspinner={deleteMessageShow}
      />
      {submitError && (
        <Alert
          onClose={(e) => setSubmitError(null)}
          dismissible={true}
          variant={"danger"}
        >
          {submitError}
        </Alert>
      )}
      {submitSuccess && (
        <Alert
          onClose={(e) => setSubmitSuccess(null)}
          dismissible={true}
          variant={"success"}
        >
          {submitSuccess}
        </Alert>
      )}
    </>
  );
}
